module.exports = __webpack_public_path__ + "img/head.26dda2ce.png";